import axios from '@/plugins/axios'


export default {
    state: {
        groupTypes: {},
        nodeHash: "",
        openedElements: []
    },
    mutations: {
        setGroupTypes(state, groupTypes){
            state.groupTypes = groupTypes
        },
        
    },
    actions: {
        async getUserSettings() {
            try {
                return axios
                    .post("http://core.lksystems.ru/mainwindow/GetUserSettings", {})
                    .then((res) => {
                        return res.data
                    })
                    .finally(() => {
                    });
            } catch (e) {
                throw e
            }
        },
        async saveUserSettings({}, data) {
            try {
                return axios
                    .post("http://core.lksystems.ru/mainwindow/SaveUserSettings", data)
                    .then((res) => {
                        return res.data 
                    })
                    .finally(() => {
                    });
            } catch (e) {
                throw e
            }
        },
        setCurrNodeHash({state}, val){
            state.nodeHash = val
        },
        setOpenedElements({state}, val){
            state.openedElements = val
        }
    },
    getters: {
        groupTypes: s => s.groupTypes,
        nodeHash(state){
            return state.nodeHash
        },
        openedElements(state){
            return state.openedElements
        }
    }
}